import { render, staticRenderFns } from "./Scroll.vue?vue&type=template&id=71f00a60&"
import script from "./Scroll.vue?vue&type=script&lang=js&"
export * from "./Scroll.vue?vue&type=script&lang=js&"
import style0 from "./Scroll.vue?vue&type=style&index=0&id=71f00a60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports